export const currencyUtils = {
  methods: {
    formatCurrency(value) {
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      let val = num.toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
